var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "17",
        height: "20",
        viewBox: "0 0 17 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M6.53101 0.0180054C5.87417 0.0180054 5.34351 0.548669 5.34351 1.20551C5.34351 1.86234 5.87417 2.39301 6.53101 2.39301H7.12476V3.66957C3.42495 4.24105 0.593506 7.43988 0.593506 11.2993C0.593506 15.5631 4.04839 19.018 8.31226 19.018C12.5761 19.018 16.031 15.5631 16.031 11.2993C16.031 9.74808 15.5746 8.30453 14.7878 7.09847L15.6822 6.20414C16.146 5.74027 16.146 4.98695 15.6822 4.52308C15.2183 4.05922 14.465 4.05922 14.0011 4.52308L13.1996 5.32465C12.1568 4.47113 10.8914 3.8848 9.49976 3.66957V2.39301H10.0935C10.7503 2.39301 11.281 1.86234 11.281 1.20551C11.281 0.548669 10.7503 0.0180054 10.0935 0.0180054H8.31226H6.53101ZM9.20288 7.14301V11.893C9.20288 12.3866 8.80581 12.7836 8.31226 12.7836C7.8187 12.7836 7.42163 12.3866 7.42163 11.893V7.14301C7.42163 6.64945 7.8187 6.25238 8.31226 6.25238C8.80581 6.25238 9.20288 6.64945 9.20288 7.14301Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }